import { render, staticRenderFns } from "./BankList.vue?vue&type=template&id=e1205fc4&scoped=true"
import script from "./BankList.vue?vue&type=script&lang=js"
export * from "./BankList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1205fc4",
  null
  
)

export default component.exports